import { clsx } from 'clsx';
import { useTheme } from '@/hooks/use-theme';
import {
  useFlashcardController,
  UseFlashcardControllerProps,
} from './hooks/use-flashcard-controller';
import { FlashcardDisplay, FlashcardDisplayProps } from './flashcard-display';
import { FlashcardProvider } from './flashcard-provider';

export type FlashcardProps = UseFlashcardControllerProps &
  FlashcardDisplayProps;

export function Flashcard({
  className,
  reference,
  displayIndex,
  preventFlipBack,
  disabled,
  onFlip,
  onNavigateTo,
  onLoad,
  selectDeck,
  ...others
}: FlashcardProps) {
  const theme = useTheme();

  const controller = useFlashcardController({
    reference,
    displayIndex,
    preventFlipBack,
    disabled,
    onFlip,
    onNavigateTo,
    onLoad,
    selectDeck,
  });

  return (
    <FlashcardProvider controller={controller}>
      <FlashcardDisplay
        className={clsx(theme.flashcard, className)}
        {...others}
      />
    </FlashcardProvider>
  );
}

Flashcard.displayName = 'Flashcard';
